import { NgDropdownPanelComponent } from '@ng-select/ng-select';

// Companion to installDropdownPopoverZIndexPatch, but for @ng-select/ng-select
// instead of ng-bootstrap dropdowns.
//
// When an ng-select uses `appendTo="body"`, NgDropdownPanelComponent moves its
// `.ng-dropdown-panel` out to <body> (see `_appendDropdown`). The panel's z-index
// is then pinned by CSS - customBootstrap.scss sets `.ng-dropdown-panel` to
// `z-index: 1056 !important` - which sits below a popover (ng-bootstrap popovers
// default to z-index 1070), so a select opened inside a popover renders *behind* it.
//
// The select's host element (`_select`) stays in place inside the popover, so we
// inspect the layer it was opened from: we read the highest z-index among its
// ancestors and lift the body-appended panel just above it. The base rule is
// `!important`, so the override must be set as an important inline declaration to
// win. This is dynamic and contextual - with nothing stacked above the panel (no
// popover, or a low-z-index ancestor) the CSS-provided z-index is left untouched.
export function installNgSelectPopoverZIndexPatch() {
    const prototype = NgDropdownPanelComponent.prototype as any;
    const original_append_dropdown = prototype._appendDropdown;

    prototype._appendDropdown = function () {
        original_append_dropdown.call(this);

        // Only body-appended panels get detached from the popover's stacking context.
        if (!this.appendTo || !this.appendTo()) return;

        const panel: HTMLElement | undefined = this._dropdown;
        const host: HTMLElement | undefined = this._select;
        if (!panel || !host) return;

        const parsed_base = parseInt(getComputedStyle(panel).zIndex, 10);
        const base_z_index = Number.isNaN(parsed_base) ? 0 : parsed_base;

        // Highest z-index of the layer the select was opened from.
        let surrounding_z_index = 0;
        let ancestor = host.parentElement;
        while (ancestor) {
            const z_index = parseInt(getComputedStyle(ancestor).zIndex, 10);
            if (!Number.isNaN(z_index)) {
                surrounding_z_index = Math.max(surrounding_z_index, z_index);
            }
            ancestor = ancestor.parentElement;
        }

        // Nothing stacked above (a plain page) leaves the CSS z-index untouched.
        // The base rule is `!important`, so we must win with an important inline value.
        if (surrounding_z_index > 0 && surrounding_z_index >= base_z_index) {
            panel.style.setProperty('z-index', String(surrounding_z_index + 1), 'important');
        }
    };
}
